import { Component, OnInit, AfterViewInit, ElementRef, inject, input, viewChild, output } from "@angular/core";
import {
  AppConfigService,
  WindowEventService,
  CustomerParam,
  DeviceService,
  ConsentRequestAction,
  ConsentResponseAction,
  IInteraction,
} from "../../../core-ui";

@Component({
  selector: "app-disclaimer",
  templateUrl: "./disclaimer.component.html",
  styleUrls: ["./disclaimer.component.scss"],
  standalone: false,
})
export class DisclaimerComponent implements OnInit, AfterViewInit {
  private config = inject(AppConfigService);
  private windowService = inject(WindowEventService);

  readonly interaction = input<IInteraction>(undefined);

  text: string;

  readonly accepted = output<void>();
  readonly rejected = output<void>();

  readonly acceptRef = viewChild("acceptRef", { read: ElementRef });

  ngOnInit(): void {
    this.text = this.config.customerParam(CustomerParam.DISCLAIMER_TEXT);
    this.windowService.init(this.interaction().getParentFrameUrl());
    if (DeviceService.isIFrame) {
      this.windowService.sendMessage(new ConsentRequestAction());
    }
  }
  ngAfterViewInit(): void {
    this.acceptRef().nativeElement.focus();
  }

  exit() {
    if (DeviceService.isIFrame) {
      this.windowService.sendMessage(new ConsentResponseAction(false));
    }
    this.rejected.emit();
  }

  accept() {
    if (DeviceService.isIFrame) {
      this.windowService.sendMessage(new ConsentResponseAction(true));
    }
    this.accepted.emit();
  }
}
